import { render, staticRenderFns } from "./MensagenPronta.vue?vue&type=template&id=073d8b07&scoped=true"
import script from "./MensagenPronta.vue?vue&type=script&lang=js"
export * from "./MensagenPronta.vue?vue&type=script&lang=js"
import style0 from "./MensagenPronta.vue?vue&type=style&index=0&id=073d8b07&prod&scoped=true&lang=scss"
import style1 from "./MensagenPronta.vue?vue&type=style&index=1&id=073d8b07&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073d8b07",
  null
  
)

export default component.exports